import dayjs, { Dayjs } from 'dayjs';

// @param visible Определяет, дата будет для отображения или отправки.
export const dateFormatted = (date: Dayjs | string | null, visible: boolean = false) =>
  date ? dayjs(date).format(visible ? 'YYYY-MM-DD' : 'YYYY-MM-DDTHH:mm:ss[Z]') : null;
